/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */

export interface Event {
  id: string;
  type: string;
  login: string;
  created_at: string;
  sentence?: string;
  iconType?: string;

  // teste(): void;
}

export class EventImpl implements Event {
  id: string;
  type: string;
  login: string;
  created_at: string;
  sentence?: string;
  iconType?: string;

  constructor(
    private eventRaw: any
  ) {
    this.id = eventRaw.id;
    this.type = eventRaw.type;
    this.login = eventRaw.actor.login;
    this.created_at = eventRaw.created_at;

    let verb, object_type, object_name, commit_name,  commit_link, file_name,
      repo_name, repo_url, repo_link, followed_user, user_url, user_link,
      dest_repo_name, dest_repo_url, dest_repo_link, gist_name, gist_url,
      gist_link, issue_name, issue_link, member_name, pull_title, pull_link;

    switch (eventRaw.type) {
      case "CommitCommentEvent":
        verb = "commented on commit";
        commit_name = eventRaw.repo.name + "@" + eventRaw.payload.comment.commit_id.substring(0, 7);
        commit_link = '<a href="' + eventRaw.payload.comment.html_url + '" target="_blank">' + commit_name + "</a>";

        this.sentence = verb + " " + commit_link;
        this.iconType = "comments-alt";
        break;
      case "CreateEvent":
        verb = "created ";
        object_type = eventRaw.payload.ref_type;
        object_name = eventRaw.payload.ref;
        if (object_type == "repository") {
          repo_name = eventRaw.repo.name.split("/");
          repo_url = "https://github.com/" + repo_name;
          repo_link = '<a href="' + repo_url + '" target="_blank">' + eventRaw.repo_name[1] + "</a>";
          this.sentence = verb + object_type + " " + repo_link;
        } else {
          repo_name = eventRaw.repo.name;
          repo_url = "https://github.com/" + repo_name;
          repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
          this.sentence = verb + object_type + " " + eventRaw.payload.ref + " at " + repo_link;
        }
        if (object_type == "tag") {
          this.iconType = "tag"
        }
        if (object_type == "repository") {
          this.iconType = "book"
        }
        if (object_type == "branch") {
          this.iconType = "plus-sign"
        }
        break;
      case "DeleteEvent":
        verb = "deleted ";
        object_type = eventRaw.payload.ref_type;
        object_name = eventRaw.payload.ref;
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + object_type + " " + object_name + " at " + repo_link;
        this.iconType = "trash";
        break;
      case "DownloadEvent":
        verb = "uploaded ";
        object_type = eventRaw.payload.ref_type;
        object_name = eventRaw.payload.ref;
        file_name = eventRaw.payload.download.name;
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + object_type + "(" + file_name + ") to " + repo_link;
        this.iconType = "paper-clip";
        break;
      case "FollowEvent":
        verb = "started following ";
        followed_user = eventRaw.payload.target.name;
        user_url = "https://github.com/" + followed_user;
        user_link = '<a href="' + user_url + '" target="_blank">' + followed_user + "</a>";
        this.sentence = verb + user_link;
        break;
      case "ForkEvent":
        verb = "forked ";
        dest_repo_name = eventRaw.payload.forkee.full_name;
        dest_repo_url = "https://github.com/" + dest_repo_name;
        dest_repo_link = '<a href="' + dest_repo_url + '" target="_blank">' + dest_repo_name + "</a>";
        this.sentence = verb + dest_repo_link;
        this.iconType = "copy";
        break;
      case "ForkApplyEvent":
        verb = "applied fork commits";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + " to " + repo_link;
        break;
      case "GistEvent":
        verb = eventRaw.payload.action + "d ";
        gist_name = "gist: " + eventRaw.payload.gist.id;
        gist_url = eventRaw.payload.html_url;
        gist_link = '<a href="' + gist_url + '" target="_blank">' + gist_name + "</a>";
        this.sentence = verb + gist_link;
        this.iconType = "file";
        break;
      case "IssueCommentEvent":
        verb = "commented on issue";
        issue_name = eventRaw.payload.issue.title;
        issue_link = '<a href="' + eventRaw.payload.issue.html_url + '" target="_blank">' + issue_name + "</a>";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + " " + issue_link + " at " + repo_link;
        this.iconType = "comments-alt";
        break;
      case "IssuesEvent":
        verb = eventRaw.payload.action + " issue";
        issue_name = eventRaw.payload.issue.title;
        issue_link = '<a href="' + eventRaw.payload.issue.html_url + '" target="_blank">' + issue_name + "</a>";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + " " + issue_link + " at " + repo_link;
        if (eventRaw.payload.action == "closed") {
            this.iconType = "check"
        } else {
            this.iconType = "exclamation-sign"
        }
        break;
      case "MemberEvent":
        verb = eventRaw.payload.action + " ";
        member_name = eventRaw.payload.member.login;
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + " " + member_name + " to " + repo_link;
        break;
      case "PublicEvent":
        verb = "open sourced ";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + repo_link;
        break;
      case "PullRequestEvent":
        verb = eventRaw.payload.action + " pull request";
        pull_title = eventRaw.payload.pull_request.title;
        pull_link = '<a href="' + eventRaw.payload.pull_request.html_url + '" target="_blank">' + pull_title + "</a>";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + " " + pull_link + " at " + repo_link;
        this.iconType = "share";
        break;
      case "PullRequestReviewCommentEvent":
        console.warn("Event " + eventRaw.type + " not shown");
        console.log(eventRaw);
        break;
      case "PushEvent":
        verb = "pushed a commit to ";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank">' + repo_name + "</a>";
        this.sentence = verb + repo_link;
        this.iconType = "upload";
        break;
      case "TeamAddEvent":
        console.warn("Event " + eventRaw.type + " not shown");
        console.log(eventRaw);
        break;
      case "WatchEvent":
        verb = "starred ";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank"> ' + repo_name + "</a>";
        this.sentence = verb + repo_link;
        this.iconType = "star";
        break;
      default:
        verb = "did something with ";
        repo_name = eventRaw.repo.name;
        repo_url = "https://github.com/" + repo_name;
        repo_link = '<a href="' + repo_url + '" target="_blank"> ' + repo_name + "</a>";
        this.sentence = verb + repo_link;
        break;
    }
  }

  // teste() {
  //   console.log(eventRaw.faIcon);
  // }
}
